import Joi from '@hapi/joi'

export const fieldUserMappingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity Required`,
        "any.required": `Operation Entity Required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Collection Point Required`,
        "any.required": `Collection Point Required`
    }),
    userID: Joi.number().invalid(0).required().label("User").messages({
        "any.invalid": `User Required`,
        "any.required": `User Required`
    }),
     allowDivisionID: Joi.number().invalid(0).required().label("Allow Division").messages({
        "any.invalid": `Allow Collection Point Required`,
        "any.required": `Allow Collection Point Required`
    }),
    isActive: Joi.boolean().label("Active")
}